import React from 'react';

import { AnalyticsContext } from './AnalyticsContext';
import { type AnalyticsProviderProps } from './types';

// eslint-disable-next-line @repo/internal/react/no-class-components
export default class AnalyticsProvider extends React.Component<AnalyticsProviderProps> {
	state = {
		analytics: this.props.analytics,
	};
	render() {
		return (
			<AnalyticsContext.Provider value={this.state}>
				{this.props.children}
			</AnalyticsContext.Provider>
		);
	}
}
